import { createFileRoute } from "@tanstack/react-router";
import { DataDeletionPage } from "@/features/legal/pages";

/** Public data-deletion status page (ALP-77): Meta's data-deletion callback returns `/data-deletion?code=…`. No sign-in. */
export const Route = createFileRoute("/data-deletion")({
  validateSearch: (raw: Record<string, unknown>): { code?: string } => (typeof raw.code === "string" && raw.code.length <= 128 ? { code: raw.code } : {}),
  head: () => ({ meta: [{ title: "Data deletion · Malfak" }] }),
  component: DataDeletionRoute,
});

function DataDeletionRoute() {
  const { code } = Route.useSearch();
  return <DataDeletionPage code={code} />;
}
